angular.module(NgAppName).directive('crNavRecentSearches', ['crResourcesService', 'PubSub', '$http', function(crResourcesService, PubSub, $http) {
	return {
		restrict: 'A',
		link: function(scope, element, attrs) {
			scope.recentSearchUrl = attrs.recentSearchUrl;
			scope.getData = function() {
				var crDataPromise = crResourcesService.getDataObject(attrs.rpcUrl);
				crDataPromise.then(function(data) {
					if (data) {
						scope.count = data.count;
						scope.items = data.items;
						scope.agent = data.branding;
						new UserTools();
					}
				});
			};
			scope.deleteItem = function(e, index, item) {
				if (e) {
					e.stopPropagation();
				}
				var deleteUrl;
				if (index !== -1) {
					deleteUrl = attrs.deleteItemUrl + '?h=' + item.hash;
				} else {
					deleteUrl = attrs.deleteAllUrl;
				}

				$http({
					method: 'GET',
					url: deleteUrl,
					headers: {'X-Requested-With': 'XMLHttpRequest'}
				})
				.success(function(data, status, headers, config) {
					if (index !== -1) {
						scope.items.splice(index, 1);
					} else {
						scope.items = [];
					}

					PubSub.publish('delete-recent-search', {index});
				})
				.error(function(data, status, headers, config) {
					// manage error
				});
			};
			scope.getData();
			PubSub.subscribe('refresh-nav-recent-searches', scope.getData);
		}
	};
}]);
